import { useEffect, useState } from 'react';
import { api } from '../api';
import { sar } from '../format';

interface Row { salesperson: string; branch: string; target: number; achieved: number; achievement_pct: number; commission_preview: number }
interface Decline { item: string; brand: string; weeks_decline: number; current_qty: number }
interface Payload {
  lens: 'L03'; date: string;
  leaderboard: Row[];
  declining_items: Decline[];
  _meta: { phase: number; mode: string; source: string };
}

export function LensSales() {
  const [data, setData] = useState<Payload | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { api<Payload>('/lenses/L03').then(setData).catch((e) => setErr(String(e))); }, []);
  if (err) return <div className="lens error">خطأ: {err}</div>;
  if (!data) return <div className="lens">جارٍ التحميل…</div>;

  const sorted = [...data.leaderboard].sort((a, b) => b.achievement_pct - a.achievement_pct);
  const totalAchieved = data.leaderboard.reduce((s, r) => s + r.achieved, 0);
  const totalTarget = data.leaderboard.reduce((s, r) => s + r.target, 0);
  const teamPct = Math.round((totalAchieved / totalTarget) * 100);

  return (
    <div className="lens">
      <header>
        <h2>L03 — المبيعات + الأهداف</h2>
        <span className="badge">{data.date}</span>
        <span className="badge src">{data._meta.source}</span>
      </header>

      <section className="widgets">
        <div className="widget"><h3>الفريق</h3><p className="big">{teamPct}%</p><p className="hint">{data.leaderboard.length} بائع</p></div>
        <div className="widget"><h3>إجمالي محقق</h3><p className="big">{sar(totalAchieved)}</p><p className="hint">من {sar(totalTarget)}</p></div>
        <div className="widget"><h3>أصناف متراجعة</h3><p className="big">{data.declining_items.length}</p><p className="hint">≥ 3 أسابيع</p></div>
      </section>

      <section className="panel">
        <h3>Leaderboard</h3>
        <table className="banks">
          <thead><tr><th>البائع</th><th>الفرع</th><th>الهدف</th><th>المحقق</th><th>%</th><th>عمولة متوقّعة</th></tr></thead>
          <tbody>
            {sorted.map((r) => {
              const cls = r.achievement_pct >= 90 ? 'u-info' : r.achievement_pct >= 70 ? 'u-warn' : 'u-critical';
              return (
                <tr key={r.salesperson}>
                  <td>{r.salesperson}</td>
                  <td>{r.branch}</td>
                  <td className="num">{sar(r.target)}</td>
                  <td className="num">{sar(r.achieved)}</td>
                  <td><span className={`pill ${cls}`}>{r.achievement_pct.toFixed(1)}%</span></td>
                  <td className="num">{sar(r.commission_preview)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>

      {data.declining_items.length > 0 && (
        <section className="panel">
          <h3>أصناف متراجعة 3+ أسابيع</h3>
          <ul className="cards">
            {data.declining_items.map((d) => (
              <li key={d.item} className="card u-warn">
                <div className="card-head">
                  <span className="pill u-warn">تراجع</span>
                  <span className="lens-tag">{d.brand}</span>
                  <span className="amount">{d.weeks_decline} أسابيع</span>
                </div>
                <p className="card-title">{d.item}</p>
                <p className="card-ctx">المتوفّر حالياً: {d.current_qty}</p>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
